var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5443_45680",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5443_45680",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACJ0lEQVRo3u2aS0sCURiGZ6ErkTbarm3khVyUl8m/oIXtQhSC/oDtJcuiNv2HaJ0JBdFdg1Zdcam0yz/QQqES7P1qpMEmHXXOzBzrwLPRWbzPmXE85/uOIPyP7/FyPWIDAbAAUiAtkZI+o+9spgk8njkRLg7CPoTKglvwDppdeJeuzVZ3Rn0Fv0f/4K7MiQUkwf327lJTRWhFyitjzaLouQcJYGEe3L12RuHnQAU0CQ0EWpTB3FXIy2zWHSDXCs5AoEUOOLQOHwDP7eEZCRDPIKBV+CioK4VnKEDUQESL8G+/hWcsQLz2LYFwwU4zr5MAUe/5cUIwJ6h2C6+TAFEFTlXhJzKnJJBXE15HASJfEF2qZn9ebXidBYhYt/BW8GRigSdg7SSw2Et4AwSIReVlAhZmCFTiQKBUFL2Ksz/da3iDBIgpJYEtjgQ2lQQeORJ4aA9vBw2OBBrALhcI9RPeQAEiJBeIcygQlwsscyiwLBdIcyiQHioB7h8h7n/E3L9G+f4jkyQeuF1KSAKbvC/mpjgSmP65mf+qe3KxobkKe4ZwSzkUm3pJImZigfnudaHVY5LYN2Nhqyi6/0Bpsa0nUDNJcTfYb4U6Al4NLq9HB+0RRDrdCYYC9YHDyyT83LaY2pp8ezo1+ZwCi+HNHpHILCgzEKhQm7UQZtRmVWh0J8CdRo3upC6N7h93ZONcuDycmZSOGtz0eNRg/fOogWjAUYOhOexhhvEBncLYNWhbVc8AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM7);
export default __webpack_public_path__ + "static/media/m7.69ecbf680f2e35f3fb715cf69be04126.svg";
export { ForwardRef as ReactComponent };